// One fetch-or-throw for the OGS asset loaders: an error page must never reach a parser as content.

async function fetchOrThrow(url: string, what: string): Promise<Response> {
  const response = await fetch(url)
  if (!response.ok) throw new Error(`${what}: ${url} -> HTTP ${response.status}`)
  return response
}

export function fetchAssetJson(url: string, what: string): Promise<any> {
  return fetchOrThrow(url, what).then((response) => response.json())
}

export function fetchAssetArrayBuffer(url: string, what: string): Promise<ArrayBuffer> {
  return fetchOrThrow(url, what).then((response) => response.arrayBuffer())
}

export async function fetchAssetBytes(url: string, what: string): Promise<Uint8Array> {
  return new Uint8Array(await fetchAssetArrayBuffer(url, what))
}
